import React, { useEffect } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { useSegment } from '../../hooks/useSegment';
import { FormTitle, FormSectionTitle } from './styles/contact-form-styles';

export const ContactFormHeader = () => {
  const { page } = useSegment();

  useEffect(() => {
    page('Atualizar Perfil');
  }, []);

  return (
    <>
      <FormTitle>
        Atualize seus dados para continuar <br />
        recebendo notificações de leilões
      </FormTitle>
      <FormSectionTitle>
        <PersonIcon width={17} height={18} />
        <h3>Dados cadastrais</h3>
      </FormSectionTitle>
    </>
  );
};
